<ion-app [class.with-dev-nav]="showDevNav">
@if (showDevNav) {
  <app-dev-nav></app-dev-nav>
}
<ion-router-outlet></ion-router-outlet>
<ion-modal #loading id="loading-modal" [backdropDismiss]="false">
  <ng-template>
    <div id="customLoadingScreenDiv">
      <div id="loaderSpinner">
        <div class="spinner-ring"></div>
      </div>
      <p class="loader-message">
        @if (customMessage && customMessage != '') {
          {{customMessage}}
        } @else {
          <ng-container i18n>Chargement des données</ng-container>
        }
      </p>
    </div>
  </ng-template>
</ion-modal>
</ion-app>
